import { useMemo } from 'react';
import { useQuery } from 'react-apollo';
import query from './data/assetGroupSelector.graphql';
export default function useAssetGroupSelector(organisationGroupId, callback) {
    const { data: { assetGroupSelector } = {}, loading, error } = useQuery(query, {
        skip: !organisationGroupId,
        variables: { organisationGroupId },
        onCompleted: ({ assetGroupSelector }) => callback ? callback(assetGroupSelector || []) : null,
    });
    const assetGroups = useMemo(() => assetGroupSelector || [], [
        assetGroupSelector,
    ]);
    return { assetGroups, error, loading };
}
